var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import BaseManagementPage from '@/components/base/BaseManagementPage';
import { TYPES } from '@/dependency-injection/types';
import DTable from '@/pages/material-management/ManageSynBol/DTable.vue';
var Filters = function () { return import('@/pages/material-management/ManageSynBol/Filters.vue'); };
var DeletePrompt = function () { return import('@/pages/material-management/ManageSynBol/DeletePrompt.vue'); };
var RestorePrompt = function () { return import('@/pages/material-management/ManageSynBol/RestorePrompt.vue'); };
var CrudSidesheet = function () { return import('@/pages/material-management/ManageSynBol/CrudSidesheet.vue'); };
var MaterialSynonymBolList = /** @class */ (function (_super) {
    __extends(MaterialSynonymBolList, _super);
    function MaterialSynonymBolList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialSynonymBolList.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.MaterialSynonymBolService;
    };
    MaterialSynonymBolList.prototype.created = function () {
        this.setDefaultSort('cbolMaterialId', false);
    };
    MaterialSynonymBolList = __decorate([
        Component({
            components: {
                filters: Filters,
                dtable: DTable,
                deletePrompt: DeletePrompt,
                restorePrompt: RestorePrompt,
                crudSidesheet: CrudSidesheet,
            },
        })
    ], MaterialSynonymBolList);
    return MaterialSynonymBolList;
}(BaseManagementPage));
export default MaterialSynonymBolList;
